import msg from "components/string-table";
import { Section } from "main";

import styles from "./SwingExperience.module.css";

export type SwingExperienceProps = {
  daysWorked?: number;
  schoolsWorked?: number;
  timesPreferred?: number;
  positiveReviews?: number;
};

export function SwingExperience(props: SwingExperienceProps) {
  const { daysWorked, schoolsWorked, timesPreferred, positiveReviews } = props;
  const hasOnlyTwoStats = checkNumberOfStats(props) === 2;

  return (
    <Section title={msg("SUB_PROFILE_SWING_EXPERIENCE_HEADER")}>
      <div>
        <ul
          className={`${styles.experienceWrapper} ${hasOnlyTwoStats ? styles.flexStart : styles.spaceBetween}`}
        >
          {!!daysWorked && (
            <Stat label={msg("SUB_PROFILE_SWING_EXPERIENCE_DAYS_WORKED")} statCount={daysWorked} />
          )}
          {!!schoolsWorked && (
            <Stat
              label={msg("SUB_PROFILE_SWING_EXPERIENCE_SCHOOLS_WORKED")}
              statCount={schoolsWorked}
            />
          )}
          {!!timesPreferred && (
            <Stat
              label={msg("SUB_PROFILE_SWING_EXPERIENCE_TIMES_PREFERRED")}
              statCount={timesPreferred}
            />
          )}
          {!!positiveReviews && (
            <Stat
              label={msg("SUB_PROFILE_SWING_EXPERIENCE_POSITIVE_REVIEWS")}
              statCount={positiveReviews}
            />
          )}
        </ul>
      </div>
    </Section>
  );
}

function formatLabel(wordStr: string) {
  // add <br /> to separate words onto separate lines
  return wordStr
    .split(" ")
    .map((word, idx, array) => {
      if (idx < array.length - 1) {
        return `${word} <br />`;
      }
      return word;
    })
    .join(" ");
}

function checkNumberOfStats(statList: SwingExperienceProps) {
  return Object.values(statList).length;
}

type statProps = {
  label: string;
  statCount: number;
};

function Stat(props: statProps) {
  const { label, statCount } = props;

  return (
    <li className={styles.statWrapper}>
      <span className={styles.statCount}>{statCount}</span>
      <span
        dangerouslySetInnerHTML={{
          __html: formatLabel(label),
        }}
        className={styles.statLabel}
      />
    </li>
  );
}
